
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/mailing-settings",
      function () {
        return require("private-next-pages/profile/mailing-settings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/mailing-settings"])
      });
    }
  